import * as React from 'react';

const SvgExclamationOutlined = (props) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		fill="none"
		viewBox="0 0 25 25"
		width="1em"
		height="1em"
		{...props}
	>
		<path
			fill="#60636B"
			fillRule="evenodd"
			d="m12.75 15.635-.724.197v-.004l-.004-.013-.013-.048-.049-.182-.172-.669a73 73 0 0 1-.52-2.215c-.375-1.714-.768-3.85-.768-5.316 0-.615.045-1.423.31-2.1.137-.346.348-.701.68-.971.345-.28.772-.429 1.26-.429s.915.149 1.26.429c.332.27.543.625.68.972.265.676.31 1.484.31 2.1 0 1.465-.393 3.6-.767 5.315a73 73 0 0 1-.742 3.066l-.013.048-.003.013-.001.003v.001zm0 0 .724.198a.75.75 0 0 1-1.448 0zm0 3.25a1.75 1.75 0 1 0 0 3.5 1.75 1.75 0 0 0 0-3.5"
			clipRule="evenodd"
		/>
	</svg>
);
export default SvgExclamationOutlined;
